import React from 'react';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import metaOverrideSet from 'Views/Page/Content/Templates/BaseOverride';
import PropTypes from 'prop-types';
import Content from './Content';

export default function ScenarioSelectionCommonInsights({ resource }) {
  return (
    <WizardStepWrapperTemplate
      layout={Content}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
    />
  );
}
ScenarioSelectionCommonInsights.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
